export default __webpack_public_path__ + "static/media/food06.368eae31.png";